import { render, staticRenderFns } from "./DemoComponent.vue?vue&type=template&id=33fb2b4c&scoped=true&"
import script from "./DemoComponent.vue?vue&type=script&lang=js&"
export * from "./DemoComponent.vue?vue&type=script&lang=js&"
import style0 from "./DemoComponent.vue?vue&type=style&index=0&id=33fb2b4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fb2b4c",
  null
  
)

component.options.__file = "DemoComponent.vue"
export default component.exports